// @flow
import React from 'react';
import {connect} from 'react-redux';
import {logExperiment} from '@homeaway/abacus-client-utils';
import {VRBO_RECENTLY_VIEWED_SERP_CAROUSEL} from '../../abacus/experiments';
import carouselActions from '../../actions/recentlyViewed';
import PropertyCarousel from '../PropertyCarousel/PropertyCarousel';
import type {PropertyCardListingShape} from '../PropertyCarousel/PropertyCard/PropertyCard';
import {
    CARDS_MIN_LIMIT,
    DESKTOP_CARDS_MAX_LIMIT
} from '../PropertyCarousel/constants';

export type RecentlyViewedPropertyShape = {
    listing: PropertyCardListingShape
};

type Props = {
    isMobile: boolean,
    title: string,
    breakpoints: Object,
    isDataLoading: Boolean,
    nextPage: typeof carouselActions.nextPage,
    listings: RecentlyViewedPropertyShape[]
};

export const RecentlyViewedCarousel = (props: Props) => {
    const {
        isMobile,
        title,
        breakpoints,
        isDataLoading,
        nextPage,
        listings
    } = props;

    if (listings.length < CARDS_MIN_LIMIT) {
        return null;
    }

    logExperiment(VRBO_RECENTLY_VIEWED_SERP_CAROUSEL);

    const onCardsShownChange = (newCardIndex, allIndicesInView) => {
        if (listings.length === allIndicesInView[allIndicesInView.length - 1]) {
            nextPage();
        }
    };

    return (
        <PropertyCarousel
            breakpoints={breakpoints}
            isMobile={isMobile}
            title={title}
            onCardsShownChange={onCardsShownChange}
            isDataLoading={isDataLoading}
            listings={
                isMobile ? listings : listings.slice(0, DESKTOP_CARDS_MAX_LIMIT)
            }
        />
    );
};
const mapStateToProps = (state) => {
    const {recentlyViewed} = state;
    return {
        listings: recentlyViewed.listings
    };
};
const mapDispatchToProps = {
    nextPage: carouselActions.nextPage
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RecentlyViewedCarousel);
